<template>
    <div class="publication__edit content-width">

        <div class="publication__edit-wrapper">
            <auto-help-form :server="server"/>
        </div>

        <div class="publication__edit-wrapper">
            <select-location />
        </div>

        <div class="publication__edit-wrapper">
            <publication-slider-gallery />
        </div>

    </div>
</template>

<script>

import StateMixin from "../mixins/StateMixin";

import AutoHelpForm from "./AutoHelpForm";
import SelectLocation from "./SelectLocation";
import PublicationSliderGallery from "./PublicationSliderGallery";

export default {
    name: "AutoHelp",
    props: ['server'],
    mixins: [StateMixin],
    components: { AutoHelpForm, SelectLocation, PublicationSliderGallery },


    methods:{
        handleSliderHeight(){
            this.$parent.handleSliderHeight()
        },

        isValid(){
            const v = this.$children.map( e => {
                return e.isValid();
            } );

            if( v.includes(false) ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true );
            return true

        }
    },



}
</script>

<style scoped>

</style>
